<!--
 * @Author: qh_feng
 * @Date: 2022-03-16 11:33:47
 * @LastEditTime: 2022-12-05 15:24:48
 * @LastEditors: your name
 * @Description: 
 * @ FilePath: Do not edit
 * @par 修改日志:
 * 内容:
 vuex的 boxDetail里面有:
 carList属性，就是4个卡片，
 有data属性，则是由属性遍历成的列表，
 oneCardInfo就是一个 简单的 左图右文的，单卡片
 例子：
 第一种
 this.$store.commit('boxDetail', {
         carList: data,
        title: '详情'
  })
  第二种
 this.$store.commit('boxDetail', {
        data: data,
        title: '详情',
        sort: [
          '企业税号',
          '创建时间',
          '企业名称',
          '联系方式',
          '企业法人',
          '企业执照',
          '法人身份证号',
          '法人营业执照',
          '企业类型',
          '法人身份证正面',
          '经验范围',
          '法人身份证反面',
          '注册时间',
          '企业状态',
          '入场时间',
          '审批状态',
          '企业位置',
          '审批意见'
        ]
      });
  第三种
  this.$store.commit('boxDetail', {
        oneCardInfo: data,
        title: '详情'
  })
-->
<template>
  <div class="car-details">
    <template v-if="detail && (detail.carList || detail.carList_format)">
      <el-tabs
        v-model="activeName"
        type="border-card"
        @tab-click="tabClick"
        :key="refreshKey"
      >
        <el-tab-pane
          :label="show4CardIndex[0]"
          name="first"
          v-if="show4CardIndex[0]"
        >
          <car-infor :data="card1" v-if="!cxbfShow"></car-infor>
          <car-infor-cxbf :data="card1" v-if="cxbfShow"></car-infor-cxbf>
        </el-tab-pane>
        <el-tab-pane
          :label="show4CardIndex[1]"
          name="second"
          v-if="show4CardIndex[1]"
        >
          <elec-infor :data="card2"></elec-infor>
        </el-tab-pane>
        <el-tab-pane
          :label="show4CardIndex[2]"
          name="third"
          v-if="show4CardIndex[2]"
        >
          <owner-info :data="card3"></owner-info>
        </el-tab-pane>
        <el-tab-pane
          :label="show4CardIndex[3]"
          name="fourth"
          v-if="show4CardIndex[3]"
        >
          <driver-infor :data="card4"></driver-infor>
        </el-tab-pane>
      </el-tabs>
    </template>
    <!-- 上面是4个切换卡片，如果不是卡片就是这的列表 -->
    <template v-else-if="detail && detail.data">
      <list
        v-if="myDetail && myDetail.length > 0"
        :uploadImgApi="detail.uploadImgApi"
        :approvalApi="detail.approvalApi"
        :openBtn="detail.openBtn"
        :title="detail.title"
        :data="myDetail"
        @submit="submit"
        @approval="approval"
      ></list>
    </template>
    <template v-else-if="detail && detail.oneCardInfo">
      <one-card :data="detail.oneCardInfo"></one-card>
    </template>
  </div>
</template>
  </div>
</template>

<script>
import CarInfor from '@/components/cards-info/carInfor.vue';
import List from '@/components/cards-info/list.vue';
import OneCard from '@/components/cards-info/one-card.vue';
import CarInforCxbf from '@/components/cards-info/carInfoCxbf.vue';
import OwnerInfor from '@/components/cards-info/ownerInfor.vue';
import DriverInfor from '@/components/cards-info/driverInfor.vue';
import ElecInfor from '@/components/cards-info/elecInfor.vue';
export default {
  props: {
    cxbfShow: {
      type: Boolean,
      default: false
    },
    detail: {
      type: Object,
      default: () => ({})
    },
    show4CardIndex: {
      type: Array,
      default: () => ['', '', '', '']
    }
  },
  components: {
    List,
    CarInfor,
    CarInforCxbf,
    OwnerInfor,
    DriverInfor,
    ElecInfor,
    OneCard
  },
  data() {
    return {
      myDetail: [],
      list: [],
      card1: {},
      card2: {},
      card3: {},
      card4: {},
      refreshKey: 'd1',
      activeName: 'first'
    };
  },
  methods: {
    approval(form) {
      if (!this.detail) {
        this.$message.error('详情信息为空');
        return;
      }
      if (this.detail.sourceData.personType) {
        form.personType = this.detail.sourceData.personType;
      }
      this.submit(form, this.detail.approvalApi);
    },
    submit(form, api) {
      switch (this.detail.api) {
        // case 'POST_hyPersonAdd':
        case 'POST_hyPersonUpdate':
          // form.personType = this.detail.sourceData.personType;
          form.personNo = this.detail.sourceData.personNo;
          break;
        case 'POST_hyCarAdd':
        case 'POST_hyCarUpdate':
          form.carFrom = this.detail.sourceData.carFrom;
          break;
        case 'POST_deviceUpdate':
          form.deviceID = this.detail.sourceData.deviceID;
          break;
        case 'POST_tollgateAdd':
          break;
        case 'PUT_hyDispositionUpdate':
          form.dispositionID = this.myDetail[1].value;
        case 'POST_hyDispositionAdd':
          form.beginTime = this.timeChage(form.beginTime);
          form.endTime = this.timeChage(form.endTime);
          break;

        default:
          // form.personNo = this.detail.sourceData.personNo;
          form.dispositionID = this.detail.sourceData.dispositionID;
          break;
      }
      if (this.detail.sourceData && this.detail.sourceData.id !== undefined) {
        form.id = this.detail.sourceData.id;
      }
      if (
        this.detail.sourceData &&
        this.detail.sourceData.personNo !== undefined
      ) {
        form.personNo = this.detail.sourceData.personNo;
      }
      //  console.log('添加更新表单',form)
      const apiUrl = api || this.detail.api;
      this.$http[apiUrl](form)
        .then((res) => {
          console.log(res);
          if (res.code == '00000') {
            this.$message.success('更新成功');
            this.$store.commit('boxDetail', null);
            this.$store.commit('boxDetailRerefsh', new Date().getTime());
          } else {
            this.$message.error('更新失败,原因：' + res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message.error('网络出了点问题，请排查');
        });

      // if (this.detail.title == '新增') {

      // } else {
      //   //修改
      // }
    },
    tabClick(tab, event) {
      console.log('tab切换');
    },
    getData() {
      this.activeName = 'first';
      if (this.detail && this.detail.carList) {
        //carList是一个对象！
        //car1另一种格式，是2个车的信息
        //....此处自己写逻辑
        this.card2 = this.card1 = this.$myPlug.sortName2cn(this.detail.carList);
        this.card3 = {
          // imgsrc: data.drivingImg,
          // tollgateAddress: data.tollgateName,
          // fullName: data.fullName,
          // identificationNumber: data.identificationNumber,
          // isEscape: data.isEscape,
          // plateColorName: data.plateColorName,
          // carColorName: data.carColorName
        };
        this.card4 = {
          // imgsrc: data.drivingImg,
          // tollgateAddress: data.tollgateAddress,
          // status: data.status,
          // fullName: data.fullName,
          // sex: data.sex,
          // identificationNumber: data.identificationNumber,
          // birthday: data.birthday,
          // isEscape: data.isEscape,
          // address: data.address
        };
        this.refreshKey = new Date().getTime();
      } else if (this.detail && this.detail.carList_format) {
        //carList_format 是一个已经格式化字典的对象
        this.card2 = this.card1 = this.detail.carList_format;
        this.refreshKey = new Date().getTime();
      } else if (this.detail && this.detail.data) {
        this.myDetail = this.detail.data;
      }
    },
    //时间格式yyyy-MM-dd转换yyyyMMdd 主用于布控管理页面
    timeChage(str) {
      if (typeof str !== 'string' || str.indexOf('-') == -1) {
        return str;
      } else {
        let arr = str.split('-');
        let string = '';
        arr.forEach((item) => {
          string += item;
        });
        //console.log('arr',arr,string)
        return string;
      }
    }
  },
  created() {
    this.getData();
  },
  watch: {
    detail(newValue) {
      if (newValue) this.getData();
    }
  }
};
</script>

<style lang="scss">
.car-details {
  width: 100%;
  .el-tabs--border-card {
    background-color: transparent !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/carDetails.vue